import React, { useState, useEffect } from 'react';
import { firestore } from '../firebase/config';
import { useParams } from 'react-router-dom';
import { Table, Button } from 'semantic-ui-react';
import SideMenu from '../SideMenu';
import { siteCode, siteLogoSmall } from "../components/Doctors";

function Readings(props) {
  const units = {
    continuousGlucoseMonitor: { Glucose: 'mg/DL' },
    bloodGlucoseMeter: { Glucose: 'mg/DL' },
    peakFlowMeter: { 'Peak Flow': 'I/min' },
    bloodPressureMonitor: {
      Upper: 'mm Hg (Systolic)',
      Lower: 'mm Hg (Diastolic)',
      Pulse: 'bpm (Pulse Rate)',
    },
    fingertipPulseOximeter: {
      SpO2: '% (Oxygen Saturation)',
      PR: 'bpm (Pulse Rate)',
      PI: '% (Perfusion Index)',
    },
    scale: { Weight: 'lbs' },
  };

  const [readings, setReadings] = useState([]);
  const params = useParams();

  useEffect(() => {
    const usersReadings = firestore
      .collection("users")
      .doc(params.id)
      .collection("readings").orderBy('created', 'desc');
    const unsubscribe = usersReadings.onSnapshot((querySnapshot) => {
      const readings = querySnapshot.docs.map((doc) => doc.data());
      setReadings(readings);
    });
    return unsubscribe;
  }, [params.id]);

  const camel2title = (camelCase) => camelCase
    .replace(/([A-Z])/g, (match) => ` ${match}`)
    .replace(/^./, (match) => match.toUpperCase());

  const exportToCSV = () => {
    const headers = ["Submitted", "Device", "Reading", "Date Time", "Note", "Doctor"];
    const rows = readings.flatMap(reading =>
      Object.entries(reading.devices).map(([device, details]) => {
        const readingDetails = Object.keys(units[device] || {}).map(label => {
          const value = details.reading[label] || '';
          return `${label}: ${value} ${units[device][label]}`;
        }).join('; ');
        return [
          `"${new Date(reading.created).toLocaleString()}"`,
          `"${camel2title(device)}"`,
          `"${readingDetails}"`,
          `"${details.date} ${details.time}"`,
          `"${details.note || ''}"`,
          `"${reading.profile?.doctor || ''}"`
        ];
      })
    );
    const csvContent = [headers, ...rows].map(e => e.join(",")).join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "readings.csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div>
      <SideMenu id={params.id} list />
      <Table className="ui selectable celled table">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell  key="th">
              <h2>
                <img src={siteLogoSmall} alt={siteCode} height="40" /> Readings {params.name ? `(${params.name})` : ''}
                
              </h2>
            </Table.HeaderCell>
            <Table.HeaderCell></Table.HeaderCell>
            <Table.HeaderCell></Table.HeaderCell>
            <Table.HeaderCell></Table.HeaderCell> 
            <Table.HeaderCell></Table.HeaderCell>
            <Table.HeaderCell>
            <Button primary style={{ marginLeft: '20px' }} onClick={exportToCSV}>Export</Button>
            </Table.HeaderCell>
          </Table.Row>
          <Table.Row>
            <Table.HeaderCell>Submitted</Table.HeaderCell>
            <Table.HeaderCell>Device</Table.HeaderCell>
            <Table.HeaderCell>Reading</Table.HeaderCell>
            <Table.HeaderCell>Date Time</Table.HeaderCell>
            <Table.HeaderCell>Note</Table.HeaderCell>
            <Table.HeaderCell>Doctor</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {readings.map((reading) => (
            Object.entries(reading.devices).map(([device, details]) => (
              <Table.Row key={`${reading.created}-${device}`}>
                <Table.Cell>{new Date(reading.created).toLocaleString()}</Table.Cell>
                <Table.Cell>{camel2title(device)}</Table.Cell>
                <Table.Cell>
                  {Object.keys(units[device] || {}).map(label => {
                    const value = details.reading[label] || '';
                    return <div key={label}>{`${label}: ${value} ${units[device][label]}`}</div>;
                  })}
                </Table.Cell>
                <Table.Cell>{details.date} {details.time}</Table.Cell>
                <Table.Cell>{details.note || ''} {reading?.createdBy?.name ? `Entered by ${reading.createdBy.name}` : (reading?.createdBy?.email ? `Entered by ${reading.createdBy.email}` : '')}</Table.Cell>
                <Table.Cell>{reading.profile?.doctor || ''}</Table.Cell>
              </Table.Row>
            ))
          ))}
        </Table.Body>
      </Table>
    </div>
  );
};

export default Readings;
